// extracted by mini-css-extract-plugin
export var divider = "_mf-0";
export var labelWrapper = "_mf-2";
export var lineSvg = "_mf-1";